import styled, { css } from 'styled-components';
import { cornerRadiusL, spaceS, spaceM, xdlColorHover, } from '@xingternal/tokens';
import { Button } from '@xingternal/button';
// *** Components ***
const SingleSelect = styled(Button) `
  border-radius: ${cornerRadiusL};
  display: flex;
  font-weight: 400;
  height: auto;
  justify-content: flex-start;
  padding-bottom: ${spaceM};
  padding-left: ${spaceS};
  padding-right: ${spaceS};
  padding-top: ${spaceM};
  width: 100%;

  ${({ $selected }) => $selected &&
    css `
      font-weight: bold;
    `}

  &:focus,
  &:hover {
    background: ${xdlColorHover};
  }
`;
export const Styled = {
    SingleSelect,
};
//# sourceMappingURL=single-select.styles.js.map